//メインメニューオープン
document.addEventListener("DOMContentLoaded", function () {
    // 重複実行を防ぐ
    if (window.scriptInitialized) {
        console.log("スクリプトは既に初期化済みです");
        return;
    }
    window.scriptInitialized = true;
    console.log("=== スクリプト初期化開始 ===");
    
    // メニュー機能のクラス
    class MenuManager {
        constructor() {
            this.overlay = document.querySelector(".overlay");
            this.html = document.documentElement;
            this.mainMenu = document.querySelector("#main-menu");
            this.menuButtons = document.querySelectorAll(".main-hamburger-button");
            this.init();
        }

        init() {
            // メニューボタンのイベントリスナー
            this.menuButtons.forEach(button => {
                button.addEventListener("click", (e) => {
                    console.log("メニューボタンがクリックされました");
                    e.preventDefault();
                    e.stopImmediatePropagation(); // 他のイベントリスナーを完全にブロック
                    this.toggleMenu();
                });
            });

            // オーバーレイのクリックでメニューを閉じる
            if (this.overlay) {
                this.overlay.addEventListener("click", (e) => {
                    console.log("オーバーレイがクリックされました");
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    this.closeMenu();
                });
            }
        }

        toggleMenu() {
            if (this.mainMenu && this.mainMenu.classList.contains("open")) {
                this.closeMenu();
            } else {
                this.openMenu();
            }
        }

        openMenu() {
            console.log("メニューを開きます");
            if (this.mainMenu) this.mainMenu.classList.add("open");
            if (this.html) this.html.classList.add("open");
            if (this.overlay) this.overlay.classList.add("show");
            
            this.menuButtons.forEach(btn => btn.classList.add("open"));
            document.querySelectorAll(".header-menu-openbtn").forEach(btn => {
                btn.classList.add("open");
            });
        }

        closeMenu() {
            console.log("メニューを閉じます");
            if (this.mainMenu) this.mainMenu.classList.remove("open");
            if (this.html) this.html.classList.remove("open");
            if (this.overlay) this.overlay.classList.remove("show");
            
            this.menuButtons.forEach(btn => btn.classList.remove("open"));
            document.querySelectorAll(".header-menu-openbtn").forEach(btn => {
                btn.classList.remove("open");
            });
        }
    }

    // メニューマネージャーを初期化
    window.menuManager = new MenuManager();

//メニュー内部
    const parentItems = document.querySelectorAll('.innnermenu-category-list li');
    const childItems = document.querySelectorAll('.category-list-submenu li');

    // 初期状態で最初の親要素と子要素にクラスを付与
    if (parentItems.length > 0) {
        parentItems[0].classList.add('submenuopen-btn');
        childItems.forEach(child => {
            if (child.getAttribute('data-index') === '0') {
                child.classList.add('submenuopen');
            }
        });
    }

    parentItems.forEach(item => {
        item.addEventListener('click', function() {
            const index = this.getAttribute('data-index');

            // 全ての親リストからクラスを削除
            parentItems.forEach(parent => {
                parent.classList.remove('submenuopen-btn');
            });

            // クリックされた親リストにクラスを付与
            this.classList.add('submenuopen-btn');

            // 全ての子リストからクラスを削除
            childItems.forEach(child => {
                child.classList.remove('submenuopen');
            });

            // 対応する子リストにクラスを付与
            childItems.forEach(child => {
                if (child.getAttribute('data-index') === index) {
                    child.classList.add('submenuopen');
                }
            });
        });
    });

    //検索ポップアップの開閉機能
    var searchTopicLink = document.querySelector(".search-topic-link");
    var searchCloseBtn = document.querySelector(".search-close-btn");
    var searchTopicBlock = document.querySelector(".search-topic-block");
    var searchInput = document.querySelector("#Search-Inline");

    // デバッグ用ログ
    console.log("検索要素の確認:");
    console.log("searchTopicLink:", searchTopicLink);
    console.log("searchCloseBtn:", searchCloseBtn);
    console.log("searchTopicBlock:", searchTopicBlock);
    console.log("searchInput:", searchInput);

    // 検索リンククリックで検索フォームを表示
    if (searchTopicLink) {
        searchTopicLink.addEventListener("click", function(e) {
            console.log("検索リンクがクリックされました");
            e.preventDefault(); // デフォルトのリンク動作を阻止
            e.stopPropagation(); // イベントの伝播を止める
            if (searchTopicBlock) {
                console.log("検索ブロックを表示します");
                searchTopicBlock.classList.add("show");
                // 検索フォームが表示されたらinputにフォーカス
                setTimeout(function() {
                    if (searchInput) {
                        searchInput.focus();
                    }
                }, 100);
            } else {
                console.log("検索ブロックが見つかりません");
            }
            return false; // さらに確実にデフォルト動作を阻止
        });
    } else {
        console.log("検索リンクが見つかりません");
    }

    // 閉じるボタンクリックで検索フォームを非表示
    if (searchCloseBtn) {
        searchCloseBtn.addEventListener("click", function() {
            searchTopicBlock.classList.remove("show");
        });
    }

    // 背景クリックで検索フォームを非表示
    if (searchTopicBlock) {
        searchTopicBlock.addEventListener("click", function(e) {
            // 検索フォーム内のクリックは無視
            if (e.target === searchTopicBlock) {
                searchTopicBlock.classList.remove("show");
            }
        });
    }

    // ESCキーで検索フォームを非表示
    document.addEventListener("keydown", function(e) {
        if (e.key === "Escape" && searchTopicBlock && searchTopicBlock.classList.contains("show")) {
            searchTopicBlock.classList.remove("show");
        }
    });
    
});

